import type { FaireProductEntity } from "../../entity_types/product";

export const p_9yydnb687e: FaireProductEntity = {
  token: "p_9yydnb687e",
  type: "product",
  name: "Red Christmas Bow Beaded Statement Earrings",
  brandToken: "b_vjqfbthsp3",
  brandName: "Brookhaven Baubles",
  imageUrl: "https://cdn.faire.com/fastly/7af14c577ea16a6306006e98b2401068f926ea3901096cc3ea73d0c856d1e437.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d773293cbf1e9ae8f7f438a0daf92c40613de21413a58c185387dc04029a15d3.jpeg",
    "https://cdn.faire.com/fastly/552ea418646186ef48bb56924a45bfe6c57a95e60886c5166226f1dc15679b19.jpeg",
    "https://cdn.faire.com/fastly/1a34b295e7bbfdf69a423b2648ade4d900b0032544c796ca8096291f0133c6e0.jpeg"
  ],
  priceDollars: 14,
  description: "Red Christmas Bow Beaded Statement Earrings - Brookhaven Baubles Southern Statement Jewelry - Christmas Earrings\n\nRed Christmas Bow Beaded Earrings - Brookhaven Baubles Southern Statement Jewelry - Christmas Earrings - Fashion Earrings for Her\n\nAvailable in red, green, or gold! Check out our other listing for all colors.\n\nThese lightweight earrings that you will practically forget you are wearing them.\n\nSize is 2.4 x 2.25 inches.\n\nOur earrings are the perfect statement for any occasion or outfit! Perfect for every occasion, from casual days to special events like weddings and birthdays. Get a pair for yourself, your bestie, or as a gift!\n\nAll posts are lead and nickel-free and very lightweight for easy everyday wear.\n\n\n\nAll images are copyrighted by Brookhaven Baubles. All rights reserved.",
  tags: [],
  msrpDollars: 28,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T16:32:07.159Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
